// @flow
import React from "react";

import styles from "./headerBar.scss";

import TicketDashboardSearchBox from "../ticketDashboardSearchBox/ticketDashboardSearchBox";
import { ticketDashboardRouteObject } from "../../containers/ticketing/ticketDashboard/ticketDashboardHelper";
import { navigateToRouteHelper } from "../../../services/helpers";

const ticketingIconUrl = require("../../../assets/images/tickets.svg");

type Props = {
  userProfile: Object,
  logout: Function,
  pageState?: Object
};

const getUserDisplayEmail = userProfile => {
  let displayString = "";
  const emptyString = " ";
  if (!userProfile) {
    return displayString;
  }
  if (userProfile.email) {
    displayString += emptyString + userProfile.email;
  }
  return displayString;
};

// const getUserDisplayLocation = userProfile => {
//   let displayString = "";
//   const emptyString = " ";
//   if (!userProfile) {
//     return displayString;
//   }
//   if (userProfile.location_name) {
//     displayString += emptyString + userProfile.location_name;
//   }
//   if (userProfile.location_code) {
//     displayString += emptyString + userProfile.location_code;
//   }
//   return displayString;
// };

const renderTicketLink = () => (
  <div
    className={`${styles.ticketLinkWrapper} cursor-p l-row j-end`}
    onClick={() => navigateToRouteHelper(ticketDashboardRouteObject)}
  >
    <div className="l-row a-center j-center">
      <img
        className={styles.ticketIcon}
        src={ticketingIconUrl}
        alt="Loading..."
      />
    </div>
    <div className={`${styles.ticketText} l-row a-center j-center`}>
      TICKETS
    </div>
  </div>
);

const isCurrentPageTicketTashboard = pageName =>
  pageName === ticketDashboardRouteObject.pageName;

const renderHeaderComponents = () => (
  <div className="l-row a-end j-center">
    <TicketDashboardSearchBox />
  </div>
);

const HeaderBar = (props: Props) => (
  <header className={`${styles.headerWrapper}`}>
    <div className={` ${styles.headerContainer} l-row a-center`}>
      <div className="header-left-part flex-56 l-row a-center">
        <div className={`${styles.pageTitle}`}>
          {isCurrentPageTicketTashboard(props.pageState.pageName) ? (
            <div
              className="cursor-p"
              onClick={() => {
                window.open(
                  "https://app.periscopedata.com/shared/c78c251d-d76a-4ce5-8afc-a00f85cfe5b3",
                  "_blank"
                );
              }}
            >
              {props.pageState.pageName}
            </div>
          ) : (
            props.pageState.pageName
          )}
          {props.pageState.betaPage ? (
            <span className={`${styles.betaSubTitle}`}> BETA </span>
          ) : null}
        </div>
        <div className="flex-15" />
        {isCurrentPageTicketTashboard(props.pageState.pageName)
          ? renderHeaderComponents(props.pageState.pageName)
          : null}
      </div>
      <div className={`${styles.headerRightPart} flex-44 l-row a-center j-end`}>
        {!isCurrentPageTicketTashboard(props.pageState.pageName)
          ? renderTicketLink()
          : null}
        <div className={`${styles.userInfo} l-col`}>
          <div className="l-row a-center j-center">
            {getUserDisplayEmail(props.userProfile)}
          </div>
        </div>
        <div className="create-cn-icn cursor-p flex-13 l-row a-center j-center" />
        <div
          className={` ${styles.logoutBtn} cursor-p flex-13 l-row j-center a-center`}
          onClick={() => props.logout()}
        >
          Logout
        </div>
      </div>
    </div>
  </header>
);

HeaderBar.defaultProps = {
  pageState: {
    pageName: "",
    betaPage: false
  }
};

export default HeaderBar;



// WEBPACK FOOTER //
// ./app/components/commons/headerBar/headerBar.js